var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile-2",
    clipPath: "url(#clip0_123_10316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.5 4.5C9.5 3.83696 9.23661 3.20107 8.76777 2.73223C8.29893 2.26339 7.66304 2 7 2C6.33696 2 5.70107 2.26339 5.23223 2.73223C4.76339 3.20107 4.5 3.83696 4.5 4.5C4.5 5.16304 4.76339 5.79893 5.23223 6.26777C5.70107 6.73661 6.33696 7 7 7C7.66304 7 8.29893 6.73661 8.76777 6.26777C9.23661 5.79893 9.5 5.16304 9.5 4.5ZM3 4.5C3 3.43913 3.42143 2.42172 4.17157 1.67157C4.92172 0.921427 5.93913 0.5 7 0.5C8.06087 0.5 9.07828 0.921427 9.82843 1.67157C10.5786 2.42172 11 3.43913 11 4.5C11 5.56087 10.5786 6.57828 9.82843 7.32843C9.07828 8.07857 8.06087 8.5 7 8.5C5.93913 8.5 4.92172 8.07857 4.17157 7.32843C3.42143 6.57828 3 5.56087 3 4.5ZM1.54062 15H12.4594C12.1813 13.0219 10.4813 11.5 8.42813 11.5H5.57188C3.51875 11.5 1.81875 13.0219 1.54062 15ZM0 15.5719C0 12.4937 2.49375 10 5.57188 10H8.42813C11.5063 10 14 12.4937 14 15.5719C14 16.0844 13.5844 16.5 13.0719 16.5H0.928125C0.415625 16.5 0 16.0844 0 15.5719Z",
    fill: "#727190"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_123_10316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.14e15e8dbd3b59e63d277a9e55fe0d5e.svg";
export { ForwardRef as ReactComponent };